import { motion } from "framer-motion";

const points = [
  { region: "North America", x: "22%", y: "38%" },
  { region: "Latin America", x: "30%", y: "68%" },
  { region: "Europe", x: "49%", y: "34%" },
  { region: "Africa", x: "52%", y: "60%" },
  { region: "Middle East", x: "60%", y: "48%" },
  { region: "Asia Pacific", x: "78%", y: "52%" },
];

export default function Network() {
  return (
    <section data-testid="network-section" className="py-32 md:py-40 border-t border-[#0E1B2E]/10 bg-white">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-8 mb-16">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-center gap-3 text-[#A5854C] mb-6">
              <div className="hairline w-12"></div>
              <span className="font-mono text-[11px] uppercase tracking-[0.35em]">Global network</span>
            </div>
            <h2 className="font-serif font-light tracking-[-0.02em] text-[#0E1B2E] text-[36px] md:text-[56px] leading-[1.02]">
              Presence <span className="italic text-[#A5854C]">across six regions.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-7 flex items-end">
            <p className="text-[#6B7684] text-[15px] md:text-[17px] leading-relaxed max-w-xl">
              A trusted network of operators, MROs, financiers, appraisers and OEM partners — mobilised the moment your mandate begins.
            </p>
          </div>
        </div>

        <div className="relative border border-[#0E1B2E]/10 aspect-[16/8] overflow-hidden bg-[#F2F2EF]" data-testid="network-map">
          {/* Real world map (public domain, Wikimedia), tinted light for the pale theme */}
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/8/80/World_map_-_low_resolution.svg"
            alt="World map"
            className="absolute inset-0 w-full h-full object-cover opacity-[0.35]"
            style={{ filter: "grayscale(1) contrast(0.9) brightness(1.02)" }}
            loading="lazy"
          />

          {/* Subtle latitude/longitude grid */}
          <svg viewBox="0 0 1000 500" className="absolute inset-0 w-full h-full pointer-events-none" preserveAspectRatio="none">
            {[125, 250, 375].map((y) => (
              <line key={y} x1="0" y1={y} x2="1000" y2={y} stroke="rgba(165,133,76,0.12)" strokeDasharray="2 6" />
            ))}
            {[250, 500, 750].map((x) => (
              <line key={x} x1={x} y1="0" x2={x} y2="500" stroke="rgba(165,133,76,0.12)" strokeDasharray="2 6" />
            ))}
          </svg>

          {/* Vignette */}
          <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(ellipse_at_center,transparent_45%,#F2F2EF_105%)]"></div>

          {points.map((p, i) => (
            <motion.div
              key={p.region}
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.6 }}
              style={{ left: p.x, top: p.y }}
              className="absolute -translate-x-1/2 -translate-y-1/2 group z-10"
              data-testid={`network-point-${i}`}
            >
              <span className="absolute -inset-2 rounded-full bg-[#C8A97E]/40 blur-md dot-pulse"></span>
              <span className="relative block w-2.5 h-2.5 rounded-full bg-[#A5854C] ring-2 ring-[#C8A97E]/40"></span>
              <span className="absolute left-4 top-1/2 -translate-y-1/2 whitespace-nowrap font-mono text-[10px] uppercase tracking-[0.28em] text-[#0E1B2E] bg-white/90 backdrop-blur px-2 py-1 border border-[#C8A97E]/40 opacity-0 group-hover:opacity-100 transition-opacity">
                {p.region}
              </span>
            </motion.div>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-2 md:grid-cols-6 gap-4">
          {points.map((p) => (
            <div key={p.region} className="border-t border-[#0E1B2E]/10 pt-4">
              <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#9AA3AE]">Region</div>
              <div className="mt-1 font-serif text-[16px] md:text-[18px] text-[#0E1B2E]">{p.region}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
